<template>
  <div class="">
    <div class="card">
      <div class="header">
        <h2>Request 테스트 구성</h2>
        <p>간단한 API를 만들으세요.</p>
      </div>
      <div>
        <!-- Select -->
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <dev-auth-input-two-modes v-bind:requestIndex="this.requestIndex" />
          </div>
        </div>
        <!-- #END# Select -->
        <!-- Select -->
        <!-- <div class="row clearfix">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <dev-auth-connection-label />
          </div>
        </div> -->
        <!-- #END# Select -->
      </div>
    </div>

    <div style="text-align: right; margin-bottom: 10px">
      <!-- <router-link to="/developer/app/authentication/fields"><button class="btn btn-default">Add Fields</button></router-link> -->
      <button
        id="saveBtn1"
        type="button"
        class="btn btn-primary"
        @click="getTestRequestDatas"
        :disabled="saveBtn"
      ><i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw circleIcon" style="display:none;"></i>
        저장
      </button>
    </div>
  </div>
</template>

<script>
import DevAuthInputTwoModes from "@/views/dev/auth/DevAuthInputTwoModes";
// import DevAuthConnectionLabel from "@/views/dev/auth/DevAuthConnectionLabel";

import eventbus from "@/store/modules/devEventBus";

// import { eventBus } from '@/main'
// import eventbus from '@/store/modules/devEventBus'
// import Urls from "@/common/urls";
// import Apiroot from "@/common/apiroot";

export default {
  components: {
    DevAuthInputTwoModes: DevAuthInputTwoModes,
    // DevAuthConnectionLabel: DevAuthConnectionLabel,
  },

  data() {
    return {
      twoStatus: false,
      formStatus: true,
      codeStatus: false,

      labelStatus: true,
      editStatus: false,
      requestIndex: 0,

      // 데이터 저장을 위한 부분
      method: null,
      url: null,
      param: [],
      headers: [],
      body: [],

      emptyParam: 0,
      blankParam: 0,

      disableBtn: false,
      saveBtn: false,
    };
  },
  methods: {
    switchView: function () {
      this.formStatus = !this.formStatus;
      this.codeStatus = !this.codeStatus;
    },
    connectionLabelForm: function () {
      this.labelStatus = !this.labelStatus;
      this.editStatus = !this.editStatus;
    },
    deleteInputs: function () {
      console.log("원래는 초기화 시켜야 하는데 그냥 사라지네?");
    },
    getTestRequestDatas() {
      this.saveBtn = true
      document.getElementsByClassName("circleIcon")[0].style.display="revert"

      eventbus.$emit("getInputsData");

      console.log("값이 들어가는지 테스트 중입니다");
      console.log(this.$store.state.devStore.paramMap);
      console.log(this.$store.state.devStore.headerMap);
      console.log(this.$store.state.devStore.bodyMap);

      // this.disableBtn = true

      // document.getElementById('saveBtn').innerHTML = '<i class="zmdi zmdi-spinner"></i>'

      console.log(this.$store.state.devStore.configureData);

      // JSON.parse(this.$store.state.devStore.configureData[0].form)[this.requestIndex].urlParam

      // for(var z = 0; z < this.$store.state.devStore.configureData.length; z++){

      var paramList = new Map();
      if (this.$store.state.devStore.paramMap[this.requestIndex] != undefined) {
        // for(var i = 0; i < this.$store.state.devStore.paramMap[this.requestIndex].length; i++){
        // console.log(this.$store.state.devStore.paramMap[this.requestIndex][i])
        paramList = this.$store.state.devStore.paramMap[this.requestIndex];
        // }
      }

      console.log(paramList);

      var headerList = new Map();

      if (
        this.$store.state.devStore.headerMap[this.requestIndex] != undefined
      ) {
        //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
        //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
        headerList = this.$store.state.devStore.headerMap[this.requestIndex];
        //     }
      }

      var bodyList = new Map();
      // if(this.$store.state.devStore.requestType == 'form-data'){
        if (this.$store.state.devStore.bodyMap[this.requestIndex] != undefined) {
          //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
          //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
          bodyList = this.$store.state.devStore.bodyMap[this.requestIndex];
          //     }
        }

      // } else {
      //   bodyList = JSON.parse(this.$store.state.devStore.rawTypedData);
      //
      // }
      // if (this.$store.state.devStore.bodyMap[this.requestIndex] != undefined) {
      //   //     for(var j = 0; j < this.$store.state.devStore.headerMap[this.requestIndex].length; j++){
      //   //         console.log(this.$store.state.devStore.headerMap[this.requestIndex][j])
      //   bodyList = this.$store.state.devStore.bodyMap[this.requestIndex];
      //   //     }
      // }

      // if(this.$store.state.devStore.bodyMap[this.requestIndex] != undefined){
      //     for(var k = 0; k < this.$store.state.devStore.bodyMap[this.requestIndex].length; k++){
      //         console.log(this.$store.state.devStore.bodyMap[this.requestIndex][k])
      //         bodyList.set(this.$store.state.devStore.bodyMap[this.requestIndex][k].keys,this.$store.state.devStore.bodyMap[this.requestIndex][k].values)
      //     }
      // }

      // console.log(this.$store.state.devStore.optionMap)
      // var optionList = new Map();
      // if(this.$store.state.devStore.optionMap[this.requestIndex] != undefined){
      //   // var check1 = 0
      //   // var check2 = 0

      //   var b = Object.values(Object.fromEntries(this.$store.state.devStore.optionMap[this.requestIndex]))
      //   console.log(Object.values(Object.fromEntries(this.$store.state.devStore.optionMap[this.requestIndex])))

      //   optionList.set(b[0], b[1])
      // }

      // console.log(optionList)

      this.$store.state.devStore.configureData[0].connection = "polling";
      this.$store.state.devStore.configureData[0].url = this.url;
      this.$store.state.devStore.configureData[0].method = this.method;
      this.$store.state.devStore.configureData[0].requestType = this.$store.state.devStore.requestType
      this.$store.state.devStore.configureData[0].header =
        Object.fromEntries(headerList);
      this.$store.state.devStore.configureData[0].urlParam =
        Object.fromEntries(paramList);

      // if(this.$store.state.devStore.requestType == 'form-data'){
        this.$store.state.devStore.configureData[0].requestBody =
            Object.fromEntries(bodyList);

      // } else {
      //   this.$store.state.devStore.configureData[0].requestBody = bodyList;
      // }

      //
      // this.$store.state.devStore.configureData[0].requestBody =
      //   Object.fromEntries(bodyList);
      this.$store.state.devStore.configureData[0].autoEmptyParam =
        this.emptyParam;
      this.$store.state.devStore.configureData[0].autoBlankParamDelete =
        this.blankParam;

      // this.$store.state.devStore.configureData[0] = data

      console.log(
        "직전 데이터 형태는~~",
        JSON.stringify(this.$store.state.devStore.configureData)
      );

      //       //여기서 저장
      var param = {};
      // if (this.$store.state.devStore.apiData.apiName.includes("Auth Session")) {
      //   param = {
      //     appCode: this.$store.state.devStore.appCode,
      //     apiCode: this.$store.state.devStore.apiCode,
      //
      //     checkType: this.$store.state.devStore.apiData.apiName,
      //     where: "request",
      //     index: 1,
      //
      //     apiSchema: JSON.stringify(this.$store.state.devStore.configureData),
      //   };
      // } else {
        param = {
          appCode: this.$store.state.devStore.appCode,
          apiCode: this.$store.state.devStore.apiCode,

          checkType: this.$store.state.devStore.apiData.apiName,
          where: "request",

          apiSchema: JSON.stringify(this.$store.state.devStore.configureData),
        };
      // }

      this.api.configSchema(param)
        .then(() => {

          this.api.selectApiSchema({apiCode : this.$store.state.devStore.apiCode})
          .then((res)=>{
            console.log("저장 : ", res);

            this.$store.dispatch("apiDetail", {result : res}).then(() => {
              this.saveBtn = false;
              document.getElementsByClassName("circleIcon")[0].style.display="none"

              // this.$router.push({
              // name: "DevAuthSettings",
              // params: {

              // },
              // });
            });

          })

        })
        .catch(() => alert("오류가 발생했습니다. auth fields"));

      // document.getElementById('saveBtn').innerHTML = '저장 후 계속'
    },
  },

  mounted() {},
  created() {

    this.saveBtn = false
    if (
      this.$store.state.devStore.apiData.apiName.replace(/"/gi, "") ==
      "Auth Session"
    ) {
      this.requestIndex = 1;
    }

    eventbus.$on("omitDatas", (res) => {
      console.log(res);

      this.emptyParam = res[0];
      this.blankParam = res[1];
    });

    eventbus.$on("method", (res, index) => {
      console.log("메소드: ", res, index);

      this.method = res.method;
      this.url = res.url;

      // this.method = res
    });

    this.$store.state.devStore.paramMap = [{}, {}, {}, {}];
    this.$store.state.devStore.headerMap = [{}, {}, {}, {}];
    this.$store.state.devStore.bodyMap = [{}, {}, {}, {}];

    //
    // this.$store.state.devStore.optionMap = [{},{},{},{}];

    this.emptyParam =
      this.$store.state.devStore.configureData[0].autoEmptyParam.replace(
        /"/gi,
        ""
      );
    this.blankParam =
      this.$store.state.devStore.configureData[0].autoBlankParamDelete.replace(
        /"/gi,
        ""
      );
    this.url = this.$store.state.devStore.configureData[0].url.replace(
      /"/gi,
      ""
    );
    this.method = this.$store.state.devStore.configureData[0].method.replace(
      /"/gi,
      ""
    );

    console.log(
      "형태 변경중:",
      this.$store.state.devStore.configureData[0].url
    );

    // console.log("request test :", this.requestIndex)
    // console.log("request test :", this.$store.state.devStore.apiData.apiName)
    // console.log("request test :", JSON.parse(this.$store.state.devStore.configureData[0].form)[this.requestIndex])

    // this.url = JSON.parse(this.$store.state.devStore.configureData[0].form)[0].url
    // this.method = JSON.parse(this.$store.state.devStore.configureData[0].form)[0].method

    // this.emptyParam = JSON.parse(this.$store.state.devStore.configureData[0].form)[0].autoEmptyParam
    // this.blankParam = JSON.parse(this.$store.state.devStore.configureData[0].form)[0].autoBlankParamDelete

    // console.log("nanmana:" )
    // console.log(this.$store.state.devStore.configureData[0].form)
    // console.log(this.$store.state.devStore.optionMap)
    // console.log(this.$store.state.devStore.configureData[0].type)
  },
  beforeDestroy() {
    this.$store.state.devStore.paramMap = null;
    this.$store.state.devStore.headerMap = null;
    this.$store.state.devStore.bodyMap = null;
    // this.$store.state.devStore.optionMap = null

    eventbus.$off("omitDatas");
    eventbus.$off("method");
  },
};
</script>
